export default [
    {
        path: "/celebrityGrade",
        name: "CelebrityGrade",
        component: resolve => require(["./Index.vue"], resolve)
    }
];



// WEBPACK FOOTER //
// ./src/views/celebrityGrade/router.js